import {SetGetListAdmin} from './thunk/setGetListAdmin';
import {SetGetListEvents} from './thunk/setGetListEvents';
import {SetGetListHistory} from './thunk/setGetListHistory';
import {SetGetViewAdmin} from './thunk/setGetViewAdmin';
import {SetPostUpdateViewAdmin} from './thunk/setPostUpdateViewAdmin'

export const Thunks = {
    SetGetListAdmin,
    SetGetListEvents,
    SetGetListHistory,
    SetGetViewAdmin,
    SetPostUpdateViewAdmin
}